module.exports = __webpack_public_path__ + "static/img/banner3.b879b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3.png
// module id = 6Ct8
// module chunks = 0